module.exports = __webpack_public_path__ + "img/slide-5-contenten.0cbf5493.png";